export function buildNsnTitle(solicitationNumber, nomenclature) {
  const baseTitle = solicitationNumber || '';
  if (!nomenclature) return baseTitle;
  return `${baseTitle} - ${nomenclature}`;
}

function withTitleAndDueDate(opportunity, dueDateField) {
  return {
    ...opportunity,
    id: opportunity.id,
    title: opportunity.title,
    dueDate: opportunity[dueDateField],
  };
}

/**
 * Normalize an opportunity record for LinkPursuitModal based on opportunity type.
 * @param {string} type
 * @param {Record<string, *>|null|undefined} opportunity
 * @returns {Record<string, *>|null}
 */
export function buildTransDataOpportunity(type, opportunity) {
  if (!opportunity) return null;

  switch (type) {
    case 'contract':
      return opportunity;
    case 'award':
      return {
        ...opportunity,
        id: opportunity.id,
        title: opportunity.title,
        setAside: opportunity.setAside,
        naics: [opportunity.NAICSCategory],
        psc: [opportunity.PSC],
      };
    case 'grant':
      return {
        ...opportunity,
        id: opportunity.id,
        title: opportunity.title,
        dueDate: opportunity.closeDate,
      };
    case 'nsn': {
      const { solicitationNumber, nomenclature, ...rest } = opportunity;
      return {
        ...opportunity,
        ...rest,
        title: buildNsnTitle(solicitationNumber, nomenclature),
      };
    }
    case 'stateLocal':
    case 'stateLocalForecast':
      return withTitleAndDueDate(opportunity, 'proposalDeadline');
    case 'stateLocalAward':
      return withTitleAndDueDate(opportunity, 'registrationDate');
    default:
      return null;
  }
}

/**
 * Normalize an opportunity record for AddToPipeline requests.
 * @param {string} type
 * @param {Record<string, *>|null|undefined} opportunity
 * @returns {Record<string, *>|undefined}
 */
export function buildPipelineOpportunityData(type, opportunity) {
  if (!opportunity) return undefined;

  switch (type) {
    case 'award':
      return {
        ...opportunity,
        naics: [opportunity.NAICSCategory],
        psc: [opportunity.PSC],
      };
    case 'contract':
      return { id: opportunity.id, naics: [opportunity.naics] };
    case 'nsn': {
      const { solicitationNumber, nomenclature, ...rest } = opportunity;
      return {
        ...rest,
        title: buildNsnTitle(solicitationNumber, nomenclature),
        naics: [],
        psc: [],
      };
    }
    case 'grant':
      return {
        id: opportunity.id,
        naics: [],
        psc: [],
        dueDate: opportunity.closeDate,
      };
    case 'stateLocal':
    case 'stateLocalForecast':
      return {
        id: opportunity.id,
        naics: opportunity.naics || [],
        psc: opportunity.psc || [],
        dueDate: opportunity.proposalDeadline,
      };
    case 'stateLocalAward': {
      const summary = opportunity.description || opportunity.aiSummary || '';
      return {
        id: opportunity.id,
        title: opportunity.title,
        summary,
        description: summary,
        agencyName: opportunity.agencyName,
        awardeeName: opportunity.awardeeName,
        awardValue: opportunity.awardValue,
        registrationDate: opportunity.registrationDate,
        naics: [],
        psc: [],
      };
    }
    default:
      return undefined;
  }
}
